import { Drawer, Input, Select, Timeline, Modal } from 'antd';
import KPageHeader from 'common/component/KPageHeader';
import KProTip from 'common/component/KProTip';
import React, { useMemo } from 'react';
import { RoutineWrapper } from './routine.style';
import AddRoutineForm from './routineForm';
import AddRoutineEditForm from './routineEditForm';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import { useGrade } from '../hooks/useGrade';
import { useRoutine } from '../hooks/useRoutine';
import { FaCircle, FaEdit, FaRegTrashAlt } from 'react-icons/fa';
import moment from 'moment';
import { GradeModel } from 'data/grade/grade.model';
import { KButton } from 'common/component/KButton';
import { weekDays } from '../../../common/constants/index';
import { RoutineModel } from 'data/routine/routine.model';

interface Props {}

const RoutineView: React.FC<Props> = () => {
  const grade = useSelector((state: RootState) => state.grade);
  const routine = useSelector((state: RootState) => state.routine);
  const [visible, setVisible] = React.useState(false);
  const [isModalVisible, setIsModalVisible] = React.useState(false);
  const [visibleEdit, setVisibleEdit] = React.useState(false);
  const [isShowRoutineClicked, setIsShowRoutineClicked] = React.useState(false);
  const [editItem, setEditItem] = React.useState({});
  const [selectedGrade, setSelectedGrade] = React.useState('');
  const [selectedSection, setSelectedSection] = React.useState('');
  const [reloadRoutine, setReloadRoutine] = React.useState(false);
  const [deleteId, setDeleteId] = React.useState({});
  const { fetchGrade } = useGrade();
  const [gradeData, setGradeData] = React.useState<GradeModel>({
    id: '',
    startTime: '',
    endTime: '',
    sections: [],
  });
  const [selectedDay, setSelectedDay] = React.useState(moment().weekday() + 1);

  const { fetchRoutine, deleteRoutine } = useRoutine();
  const filteredRoutine: RoutineModel[] = [];

  const showDeleteModal = () => {
    setIsModalVisible(true);
  };
  const showDrawer = () => {
    setVisible(true);
  };

  const onClose = () => {
    setVisible(false);
  };
  const onEditClose = () => {
    setVisibleEdit(false);
  };
  const handleCancel = () => {
    setIsModalVisible(false);
  };
  const handleOk = (item: any) => {
    deleteRoutine(item, setReloadRoutine);
    setIsModalVisible(false);
  };

  const label = (start: string, end: string) => (
    <div className="mainTimeLabel">
      {/* {day_type.map((item) => item.value === day && <div className="timeLabel">{item.title}</div>)} */}
      <div className="timeLabel">{moment(start, 'kk:mm:ss').format('hh:mm a')}</div>
      <div className="timeLabel">to</div>
      <div className="timeLabel">{moment(end, 'kk:mm:ss').format('hh:mm a')}</div>
    </div>
  );

  const handleGetRoutine = () => {
    if (selectedGrade !== '' && selectedSection !== '') {
      fetchRoutine(selectedGrade, selectedSection);
      setIsShowRoutineClicked(true);
    }
  };

  routine.data.map((weekdayRoutine) => {
    if (weekdayRoutine.day === selectedDay) {
      filteredRoutine.push(weekdayRoutine);
    }
  });

  React.useEffect(() => {
    fetchGrade();
  }, []);

  React.useEffect(() => {
    if (reloadRoutine === true && isShowRoutineClicked) {
      fetchRoutine(selectedGrade, selectedSection);
      setReloadRoutine(false);
    }
  }, [reloadRoutine]);
  return (
    <RoutineWrapper>
      <KPageHeader title="Routine" rightButtonTitle="Add Routine" onRightButtonClick={showDrawer} />
      <Drawer
        title={<h2>Add Routine</h2>}
        width={720}
        visible={visible}
        closable={false}
        onClose={onClose}
        bodyStyle={{ paddingBottom: 80 }}
      >
        <AddRoutineForm onSetReloadRoutine={setReloadRoutine} onVisibleChange={setVisible} />
      </Drawer>
      <Drawer
        title={<h2>Edit Routine</h2>}
        width={720}
        visible={visibleEdit}
        closable={false}
        onClose={onEditClose}
        bodyStyle={{ paddingBottom: 80 }}
      >
        {
          <AddRoutineEditForm
            value={editItem}
            onVisibleChange={setVisibleEdit}
            onSetReloadRoutine={setReloadRoutine}
          />
        }
      </Drawer>
      <KProTip
        title="Page Hint"
        description="This page is for viewing and managing all the routines of all grade."
      />
      <section className="searchSection">
        <Input.Search className="search" placeholder="Search from here..." />
      </section>

      <section className="section-wrapper">
        <section className="gradeDropdown">
          <Select
            defaultValue="Select Grade"
            style={{ width: '180px', marginRight: 10 }}
            onSelect={(value) => {
              setSelectedGrade(value);
              grade.data.map((item) => {
                if (item.id === value) {
                  setGradeData(item);
                }
              });
            }}
          >
            {grade.data.map((item) => (
              <Select.Option value={item.id}> {item.id}</Select.Option>
            ))}
          </Select>
          <Select
            defaultValue="Select Section"
            style={{ width: '180px', marginRight: 10 }}
            onSelect={(value) => {
              setSelectedSection(value);
            }}
          >
            {gradeData.sections.map((section) => (
              <Select.Option value={section.id}>{section.id}</Select.Option>
            ))}
          </Select>
          <KButton onClick={handleGetRoutine}>Show Routine</KButton>
        </section>
        {isShowRoutineClicked && (
          <section className="routineOfWeek">
            <h3>Routine of the week</h3>
            <section className="page-tabs">
              {weekDays.map((item, index) => (
                <div
                  key={index}
                  onClick={() => {
                    setSelectedDay(item.id);
                  }}
                  className={`page-tabs-item ${item.id === selectedDay ? 'active' : ''}`}
                >
                  {item.title}
                </div>
              ))}
            </section>

            <section className="timeline">
              <Timeline mode={'left'} className="timeline">
                {filteredRoutine.map((item) => {
                  console.log('item ', item);
                  return (
                    <Timeline.Item label={label(item.start, item.end)} color="green">
                      <div className="subTeacher">
                        <div className="innerSubTeacher">
                          <div className="actions">
                            <div className="subName">{item.subject.title}</div>

                            <div>
                              <FaEdit
                                style={{ marginRight: '5px' }}
                                onClick={() => {
                                  setVisibleEdit(true);
                                  setEditItem(item);
                                }}
                              />
                              <FaRegTrashAlt
                                onClick={() => {
                                  setDeleteId(item);
                                  showDeleteModal();
                                }}
                              />
                              <Modal
                                title="Are you sure you want to delete?"
                                visible={isModalVisible}
                                onOk={() => handleOk(deleteId)}
                                okType="danger"
                                onCancel={handleCancel}
                              />
                            </div>
                          </div>
                          <div className="flex">
                            <FaCircle
                              style={{ color: 'var(--green)', margin: '3px 8px 3px 0px' }}
                            />
                            <div className="teacherName">{item.teacher.__user__.full_name}</div>
                          </div>
                        </div>
                      </div>
                    </Timeline.Item>
                  );
                })}
              </Timeline>
            </section>
          </section>
        )}
      </section>
    </RoutineWrapper>
  );
};

export default RoutineView;
